// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"e98a0ec5","368":"b930f920","380":"c91ef758","720":"74e50856","968":"1fae83bd"}[chunkId] + ".chunk.css";
};